import { useEffect } from 'react'
import { siteConfig } from '../config/site'

/**
 * Affiliate link cloaking page
 * Users see a clean URL like /anmelden instead of the affiliate tracking URL
 */
const AffiliateRedirect = () => {
  useEffect(() => {
    // Redirect to affiliate link immediately
    window.location.href = siteConfig.affiliate.link
  }, [])

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <p>Weiterleitung...</p>
    </div>
  )
}

export default AffiliateRedirect

